import { Mail, Globe, MapPin } from "lucide-react";
import { EVENT } from "@/data/eventData";

const LOGO_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_3da7d792-db89-448a-b5af-6ec6bdeb0313/artifacts/idk7f7k4_logo.png";

export default function Footer() {
  return (
    <footer className="relative border-t border-cyan-900/30 bg-[#020610] pt-16 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-md bg-white/95 p-1 ring-1 ring-cyan-500/30">
              <img src={LOGO_URL} alt="Convergence Experts" className="h-full w-full object-contain" />
            </div>
            <div>
              <div className="font-display text-white font-semibold">
                Convergence Experts
              </div>
              <div className="mono text-[10px] uppercase tracking-widest text-cyan-300">
                Organiser
              </div>
            </div>
          </div>
          <p className="mt-5 text-slate-400 text-sm max-w-md">
            {EVENT.name} · {EVENT.dates} · {EVENT.venue}.
          </p>
        </div>

        <div className="md:col-span-4">
          <div className="mono text-[10px] uppercase tracking-widest text-cyan-300 mb-4">
            Contact
          </div>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-cyan-300" />
              <a href={`mailto:${EVENT.emails.info}`} className="hover:text-cyan-300">
                {EVENT.emails.info} <span className="text-slate-500">· general / sponsor / exhibitor</span>
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-cyan-300" />
              <a href={`mailto:${EVENT.emails.speaker}`} className="hover:text-cyan-300">
                {EVENT.emails.speaker} <span className="text-slate-500">· speakers</span>
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Globe className="w-4 h-4 text-cyan-300" />
              <span>{EVENT.domain}</span>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="w-4 h-4 text-cyan-300" />
              <span>{EVENT.venue}</span>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="mono text-[10px] uppercase tracking-widest text-cyan-300 mb-4">
            Navigate
          </div>
          <ul className="space-y-2 text-sm text-slate-300">
            {[
              ["about", "About"],
              ["speakers", "Speakers"],
              ["agenda", "Agenda"],
              ["partners", "Partners"],
              ["sponsors", "Sponsors"],
              ["contact", "Contact"],
            ].map(([id, label]) => (
              <li key={id}>
                <a href={`#${id}`} className="hover:text-cyan-300">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-12 pt-6 border-t border-cyan-900/30 flex flex-wrap gap-4 items-center justify-between">
        <p className="mono text-[10px] uppercase tracking-widest text-slate-500">
          © {new Date().getFullYear()} Convergence Experts. All rights reserved.
        </p>
        <p className="mono text-[10px] uppercase tracking-widest text-slate-500">
          Built for {EVENT.domain}
        </p>
      </div>
    </footer>
  );
}
